module.exports = __webpack_public_path__ + "static/media/coming-soon.46c180a3.png";